export const INTRO_SET_VALUE = 'atRetirement/intro/setValue/';

export const REFERRER_ID_SET_VALUE = INTRO_SET_VALUE + 'refererId';

export const setReferrerIdValue = value => ({type: REFERRER_ID_SET_VALUE, value});

// intro page rendering action
export const INTRO_RENDER_TRACKING_VALUE = 'atRetirement/intro/transition/renderTracking';
export const setIntroRenderTracking = () => ({ type: INTRO_RENDER_TRACKING_VALUE });
